import { INewsRespomse } from "models/response/news-response";

export interface NewsDetailsState {
  newsDetails: INewsRespomse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setNewsDetails: 'setNewsDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface NewsDetailsAction {
  type: ActionType;
  payload: any;
}

export const NewsDetailsReducer = (
  state: NewsDetailsState,
  action: NewsDetailsAction
): NewsDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setNewsDetails:
      return {
        ...state,
        newsDetails: action.payload,
        error: null,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: action.payload,
      };
    case ACTION_TYPES.setError:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};